const fields = {
    config: {columns: 2},
    fields: [
        {
            name: "tabletDimensionsD",
            label: "D - Wymiar (mm)",
            column: 1,
            type: "number",
            scale: 2,
        },
        {
            name: "tabletDimensionsW",
            label: "W - Wymiar (mm)",
            column: 1,
            type: "number",
            scale: 2,
        },
        {
            name: "tabletDimensionsL",
            label: "L - Wymiar (mm)",
            column: 1,
            type: "number",
            scale: 2,
        },
        {
            name: "tabletDimensionsTmin",
            label: "Tmin - Wymiar (mm)",
            column: 1,
            type: "number",
            scale: 2,
        },
        {
            name: "tabletDimensionsTmax",
            label: "Tmax - Wymiar (mm)",
            column: 1,
            type: "number",
            scale: 2,
        },
        {
            name: "tabletDimensionsR",
            label: "R - Wymiar (mm)",
            column: 1,
            type: "number",
            scale: 2,
        },
        {
            name: "imageLegend1",
            column: 2,
            label: "Legenda",
            type: "staticImage",
            fileName: "tablet_size.png",
        }


    ]
};

export default fields;
